"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["Auth"] = "action:auth-button:auth";
    EventTypes["GetUser"] = "action:auth-button:user:get";
    EventTypes["Init"] = "action:auth-button:init";
    EventTypes["OpenAuthWindow"] = "action:auth-button:auth-window:open";
    EventTypes["Ready"] = "action:auth-button:ready";
    EventTypes["User"] = "action:auth-button:user";
    EventTypes["UserChange"] = "action:auth-button:user-change";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
//# sourceMappingURL=EventTypes.js.map